/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Modal from "../Modal/index";
import LoadingOverlay from "react-loading-overlay";
import SmsVerify from "./SmsVerify";
import ExpirePassword from "./ExpirePassword";
import { ClipLoader } from "react-spinners";
import TermsOfUse from "../Modal/TermsOfUse";
import NumberFormat from "react-number-format";

import StaticModal from "../shared/StaticModal";
import KvkkModal from "../shared/KvkkModal";
import {
  beginAuthenticate,
  beginControlCandidate,
  getIp,
  selectAuthenticate,
  beginAddLead,
  authenticateOtp,
  getKvkkService
} from "../../../state/ducks/login/index";
import { selectAlertMessage } from "../../../state/ducks/alert/index";
import ReactPixel from "react-facebook-pixel";
import $ from "jquery";
import Inputmask from "inputmask";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

function slideBImage() {
  var arrayOfPartenaires = [
    "/assets/img/loginBackground/loginback_1.jpg",
    "/assets/img/loginBackground/loginback_2.jpg"
  ];
  var loaders = 0;
  function cycleImages() {
    document.body.className = "bodytest";
    document.body.id = "bodytest";
    var element = arrayOfPartenaires[loaders];

    // $("#bodytest").animate({ opacity: 1 }).hide().fadeIn("slow");
    $("#bodytest").css({ 'background-image': 'url(' + element + ')' }).animate({ opacity: 1 }).hide().fadeToggle("slow");
    //document.body.background = element;

    if (loaders < arrayOfPartenaires.length) {
      loaders = loaders + 1;
      if (loaders >= arrayOfPartenaires.length) {
        loaders = 0;
      }
    }
    else {
      loaders = 0;
    }
  }
  cycleImages();
  setInterval(function () { cycleImages() }, 3000);
};
function changebg(corporate) {
  document.body.className = "";
  if (corporate) {
    var num = Math.ceil(Math.random() * 2);
    document.body.background = "#000 url('assets/img/loginBackground/loginback_" + num + ".jpg') no-repeat top left";
    document.body.style.backgroundSize = "cover";
  } else {
    num = Math.ceil(Math.random() * 2);
    document.body.background = "assets/img/loginBackground/loginback_" + num + ".jpg";
  }
}


function formControl(stateAd, stateSoyad, gsmControl) {

  var kvkk_check = document.getElementById("kvkk_check");
  var mesaj = document.getElementById("mesaj");
  var control = true;
  mesaj.innerHTML = "";
  var control = true;

  if (/^[a-zA-Z_ğüşıöçĞÜŞİÖÇ ]+$/.test(stateAd)) {

  } else {

    mesaj.innerHTML += "<br/>Lütfen geçerli bir Ad giriniz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }

  //Soyad alanı
  if (/^[a-zA-Z_ğüşıöçĞÜŞİÖÇ ]+$/.test(stateSoyad)) {

  } else {

    mesaj.innerHTML += "<br/>Lütfen geçerli bir Soyad giriniz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }

  // var regextel = /^5[0-9]{2}[0-9]{3}[0-9]{2}[0-9]{2}/.test(stateGsm.replace(/\D/g, ''));

  if (gsmControl) {
  }
  else {
    mesaj.innerHTML += "<br/>Lütfen geçerli bir GSM numarası giriniz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }

  if (kvkk_check.checked === false) {
    mesaj.innerHTML +=
      "<br/>Kişisel verilerin korunması aydınlatma ve bilgilendirmesi onayı boş bırakılamaz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }
  return control;
}


class Login extends Component {
  state = {
    userName: "",
    password: "",
    gsm: "",
    loginType: 1,
    platform: "web",
    token: "",
    corporate: this.props.match.params.type === "corporate",
    candidate: this.props.match.params.type === "aday",
    corporateCss: "",

    name: "",
    surname: "",
    reklamIzni: false,
    kvkkIzni: false,
    gsmControl: false,
    ip: "",
    kvkkMetni: "",
    isKvkkModalOpen: false,
  };

  loginChangeType() {
    var loginPassword = document.getElementById("loginPassword");
    var iconLoginPassword = document.getElementById("iconLoginPassword");
    if (iconLoginPassword != null && loginPassword != null) {

      if (loginPassword.type == 'password') {
        loginPassword.type = 'text';

        iconLoginPassword.classList.remove("t-icon-eye-blocked");
        iconLoginPassword.classList.add("t-icon-eye");
      } else {
        loginPassword.type = 'password';
        iconLoginPassword.classList.remove("t-icon-eye");
        iconLoginPassword.classList.add("t-icon-eye-blocked");
      }
    }

  };

  beginAuthenticate = (event) => {
    event.preventDefault();
    const postData = {
      username: this.state.userName,
      password: this.state.password,
      loginType: this.state.loginType,
      platform: this.state.platform,
      token: this.state.token,
      authType: 1,
    };
    this.props.beginAuthenticate(postData);
    this.setState({
      userName: "",
      password: "",
    });

    this.createCaptchaToken();

  };

  authenticateOtp = (event) => {
    event.preventDefault();
    const postData = {
      username: this.state.userName,
      password: this.state.password,
      platform: this.state.platform,
      token: this.state.token,
      verifyType: 1,
    };
    this.props.authenticateOtp(postData);
    this.setState({
      userName: "",
      password: "",
    });
    this.createCaptchaToken();
  };

  beginControlCandidate = (event) => {
    event.preventDefault();

    var control = true;
    var adayTelefonNo = document.getElementById('adayTelefonNo').value;
    var adaytelno = adayTelefonNo.replace(/\D/g, ''); // sayılar dışındaki tüm karakterleri siliyorum

    if (adaytelno.length < 10) {
      document.getElementById('adayTelefonNo').parentElement.classList.add("t-error"); // kutunun içini kırmızız yapıyorum.
      document.getElementById("adayTelefonNo").nextElementSibling.innerHTML = "<i class='t-icon-error text-danger'></i>";
      control = false;
    }
    const postData = {
      username: this.state.gsm,
      loginType: 1,
      platform: this.state.platform,
      token: this.state.token,
      authType: 2,
    };

    if (control) {
      this.props.beginControlCandidate(postData);
    }

    this.createCaptchaToken();
  };
  maskAndRegexInput() {
    var userName = document.getElementById("userName");
    var adayTelefonNo = document.getElementById("adayTelefonNo");
    if (userName != null && adayTelefonNo != null) {

      Inputmask("(999) 999-99-99").mask(adayTelefonNo);
      Inputmask({ regex: "[0-9]{11}" }).mask(userName);
    }

  }
  getIpAdress() {
    getIp().then(
      response => {
        this.setState({ ip: response });
      },
      error => { }
    );
  }



  getKvkk = () => {
    getKvkkService().then(
      (response) => {
        console.log(response);
        this.setState({
          isKvkkModalOpen: true,
          kvkkMetni: response.data?.kvkkMetni ?? "", // KVKK metnini de set et
        });
      },
      (error) => {
        console.error("KVKK metni alınamadı", error);
      }
    );
  };

  closeKvkkModal = () => {
    this.setState({ isKvkkModalOpen: false });
  };

  componentDidMount() {
    this.getIpAdress();
    this.maskAndRegexInput();
    if (this.state.corporate === true) {
      this.setState({ corporateCss: "-krmsl" });
      this.props.history.push("/giris/Corporate");
    } else {
      this.props.history.push("/giris");
    }
    changebg(this.state.corporate);
    ReactPixel.init("210664537388285");
    ReactPixel.pageView();
    this.createCaptchaToken();
    this.props.login.leadSuccess = false;

    var LoggingInFromDifferentBrowser = sessionStorage.getItem("LoggingInFromDifferentBrowser");
    if (LoggingInFromDifferentBrowser == "true") {
      sessionStorage.setItem("LoggingInFromDifferentBrowser", false);
      var mesaj = document.getElementById("mesaj");
      mesaj.innerHTML = "<br/>Başka bir ortamdan oturum açıldığı için oturumunuz sonlandırılmıştır. Giriş yaparak işleminize devam edebilirsiniz.";
      $("#hata_mesaji").modal("show");

    }

  }

  componentDidUpdate() {
    if (this.props.login?.controlCandidate) {
    } else if (this.props.login?.controlNewCandidate) {
      this.props.history.push("/yeniuyelik");
    }
  }

  createCaptchaToken() {
    var that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token: token });
        });
    });
  }

  setReklamIzni = (e) => {
    this.setState({
      reklamIzni: e.target.checked,
    });
  };
  setKvkk = (e) => {
    this.setState({
      kvkkIzni: e.target.checked,
    });
  };

  beginAddLead = (event) => {
    event.preventDefault();

    var control = formControl(this.state.name, this.state.surname, this.state.gsmControl);

    if (control) {
      var adaytelno = this.state.gsm.replace(/\D/g, ''); // sayılar dışındaki tüm karakterleri siliyorum
      const postData = {
        adi: this.state.name,
        soyadi: this.state.surname,
        tel: adaytelno,
        acikRizaIzni: this.state.kvkkIzni,
        reklamIzni: this.state.reklamIzni,
        token: this.state.token,
      };
      this.props.beginAddLead(postData);

    }
  };


  render() {
    const { alert, login } = this.props;
    let krmsl = this.state.corporateCss;
    return (
      <LoadingOverlay
        active={login.loggingIn}
        spinner={<ClipLoader />}
        styles={{
          overlay: (base) => ({
            ...base,
            position: "fixed",
          }),
        }}
      >
        <Modal message={alert?.message} type={alert?.type} />
        <div className="container-fluid">
          <div className="row d-flex align-items-center justify-content-center vh-100">
            <div className="w-100 d-flex justify-content-center align-items-center flex-column">
              <div className="col-10 col-md-7 col-lg-6 col-xl-4 t-sifreAlani">
                <div className="row no-gutters">
                  {/* LOGO */}
                  <div className="col-12 d-flex justify-content-center pb-4">
                    <img src="/assets/img/svg/logo_internetSube.svg" width="250" height="87" alt="internetSube" />
                  </div>
                  {/* TAB SEKMELERİ */}
                  <div className="col-12 pt-3 d-flex justify-content-center nav nav-pills" id="pills-tab">
                    <a className="t-loginTabButon active" id="pills-home-tab" data-toggle="pill" data-target="#loginUye" style={{ color: "white" }}>ÜYELİĞİM VAR</a>
                    <a className="t-loginTabButon" id="pills-profile-tab" data-toggle="pill" data-target="#loginAday" style={{ color: "white" }} onClick={(e) => {
                      this.props.login.leadSuccess = false;
                      this.setState({
                        name: "",
                        surname: "",
                        gsm: "",
                        kvkkIzni: false,
                        reklamIzni: false,
                      });
                    }}>ADAY MÜŞTERİ</a>
                  </div>
                  <div className="col-12">
                    <div className="tab-content" id="pills-tabContent">
                      {/* Müsteri Login İçerik*/}

                      <div className="tab-pane fade show active" id="loginUye">
                        <form onSubmit={this.authenticateOtp}>
                          <div className="row no-gutters p-4  justify-content-center" style={{ height: '230px' }}>
                            <div className="col-12 col-lg-8">
                              <span className="t-loginText pl-3">TC Kimlik / VKN / Üye No</span>
                            </div>
                            <div className="col-12 col-lg-8">
                              <div className="t-inputLogin">
                                <div><img src="/assets/img/svg/icon_ayyildiz.svg" width="25" height="22" alt="icon" /></div>

                                <NumberFormat
                                  id="userName"
                                  displayType={"input"}
                                  autoComplete="new-password"
                                  className={"decimalnumber"}
                                  maxLength={11}
                                  placeholder="T.C. Kimlik / VKN / Üye No"
                                  value={this.state.userName}
                                  onChange={(e) => {
                                    this.setState({
                                      userName: e.target.value.replace('_', ''),
                                    });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            <div className="col-12 col-lg-8 pt-3">
                              <span className="t-loginText pl-3">Şifre</span>
                            </div>
                            <div className="col-12 col-lg-8">
                              <div className="t-inputLogin">
                                <div><i className="t-icon-lock1" /></div>
                                <input type="password"
                                  id="loginPassword" placeholder="Şifrenizi Giriniz"
                                  autoComplete="new-password"
                                  value={this.state.password}
                                  onChange={(e) => {
                                    this.setState({
                                      password: e.target.value,
                                    });
                                  }}
                                />
                                <div className="ml-auto"><i id="iconLoginPassword" className="t-icon-eye-blocked t-cursorPointer" onClick={this.loginChangeType} /></div>
                              </div>
                            </div>
                            <div className="col-12 col-lg-8  pr-3 d-flex justify-content-end">

                              <Link
                                to={
                                  this.state.corporate
                                    ? "/sifremiunuttum/corporate"
                                    : "/sifremiunuttum"
                                }
                              >
                                <small className="t-loginLink">
                                  Şifre Al / Şifremi Unuttum
                                </small>
                              </Link>
                            </div>
                          </div>
                          {/* Giriş BUTTON */}
                          <div className="row no-gutters p-2  justify-content-center align-items-end">
                            <div className="col-auto">
                              <button type="submit" className="t-loginGirisButton">
                                <span />
                                <span className="pb-1">GİRİŞ</span>
                                <i className="t-icon-arrow-right2" style={{ fontSize: '14pt' }} />
                              </button>
                            </div>
                          </div>
                          {/* UYARI */}
                          <div className="row no-gutters p-2  justify-content-center align-items-end">
                            <div className="text-white p-3 m-2" style={{ textAlign: 'center', fontSize: "10pt", boxShadow: '0 1rem 2rem hsl(0 0% 0% / 10%)', backgroundColor: '#ffbb071f', borderRadius: '2ch' }}>
                              Değerli Müşterimiz, lütfen kişisel bilgilerinizi (TC kimlik numarası, şifre vb.) kimseyle paylaşmayın ve parolanızın güçlü ve benzersiz olmasına dikkat ederek parolanızı düzenli olarak güncelleyin. Güvenliğiniz bizim önceliğimizdir!
                            </div>
                          </div>
                        </form>
                      </div>

                      {/* Aday Müşteri FORMU*/}
                      <div className="tab-pane fade" id="loginAday">
                        {login.leadSuccess ? (
                          <div className="row no-gutters p-4 justify-content-center" style={{ height: '287px' }}>
                            <div className="col-12 col-lg-8 pt-4 text-center" style={{ color: '#FFFFFF' }}>
                              <i className="t-icon-check_circle" style={{ fontSize: '40pt', color: '#95C11F' }} />
                              <div className="pt-4" style={{ fontSize: '14pt' }}>
                                Bilgileriniz başarılı şekilde alınmıştır. En kısa zamanda sizinle iletişime geçilecektir.
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="row no-gutters p-4 justify-content-center" style={{ height: '400px' }}>
                              <div className="col-12 col-lg-8 pb-0 text-center" style={{ color: '#95C11F' }}>
                                FORMU GÖNDERİN SİZİ ARAYALIM
                              </div>
                              <div className="col-12 col-lg-8">
                                <span className="t-loginText pl-3">Adınız</span>
                              </div>
                              <div className="col-12 col-lg-8">
                                <div className="t-inputLogin">
                                  <div><i className="t-icon-user" /></div>
                                  <input id="adayAdi" type="text" placeholder="Adınızı Giriniz" required
                                    value={this.state.name}
                                    onChange={(e) => {
                                      this.setState({
                                        name: e.target.value,
                                      });
                                    }} />
                                  <div />
                                </div>
                              </div>
                              <div className="col-12 col-lg-8">
                                <span className="t-loginText pl-3">Soyadınız</span>
                              </div>
                              <div className="col-12 col-lg-8">
                                <div className="t-inputLogin">
                                  <div><i className="t-icon-user" /></div>
                                  <input id="adaySoyadi" type="text" placeholder="Soyadınızı Giriniz" required
                                    value={this.state.surname}
                                    onChange={(e) => {
                                      this.setState({
                                        surname: e.target.value,
                                      });
                                    }} />
                                  <div />
                                </div>
                              </div>
                              <div className="col-12 col-lg-8">
                                <span className="t-loginText pl-3">Telefon Numaranız</span>
                              </div>
                              {/* <div className="col-12 col-lg-8">
                                <div className="t-inputLogin">
                                  <div><i className="t-icon-phone1" /></div>
                                  <input id="adayTelefonNo" className="telefonnumber" type="text" placeholder="Telefon Numaranızı Giriniz" required
                                    value={this.state.gsm}
                                    onChange={(e) => {
                                      this.setState({
                                        gsm: e.target.value.replace(/\D/g, ''),
                                      });
                                    }} /> 
                                  <div />
                                </div>
                              </div> */}



                              <div className="col-12 col-lg-8">
                                <div className="" style={{ background: "white", display: "flex", padding: "3px 20px 3px 20px", borderRadius: "1.5em" }} >
                                  <PhoneInput country='tr' value={this.state.gsm} placeholder="+90 500 000 00 00"
                                    buttonStyle={{ border: "none", background: "white" }}
                                    inputClass="new-phone-input"
                                    countryCodeEditable={false}
                                    onChange={(value, data, event, formattedValue) => {
                                      this.setState({
                                        gsm: value.replace(/\D/g, ''),
                                        gsmControl: (data.format.length > 20 && formattedValue.length == 20) || data.format.length == formattedValue.length,
                                      });
                                    }} />
                                  <div />
                                </div>
                              </div>


                              <div className="col-12 col-lg-10 col-xl-8 pb-0 pt-2 t-loginText d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  id="kvkk_check"
                                  name="kvkk_check"
                                  onChange={this.setKvkk}
                                  value={this.state.kvkkIzni}
                                  required
                                  style={{ width: "24px", height: "24px" }} />
                                <span style={{ paddingLeft: 10, fontSize: 12 }}>
                                  <strong>
                                    <a
                                      href="#"
                                      className="t-loginLink "
                                      onClick={this.getKvkk}
                                    >
                                      Kişisel verilerin korunması aydınlatma ve bilgilendirmesi
                                    </a>
                                  </strong>
                                  'ni okudum, kabul ediyorum.
                                </span>
                              </div>
                              <div className="col-12 col-lg-10 col-xl-8 pb-2 t-loginText d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  id="reklam_check"
                                  name="reklam_check"
                                  onChange={this.setReklamIzni}
                                  value={this.state.reklamIzni}
                                  style={{ width: "30px", height: "30px" }} />
                                <span style={{ paddingLeft: 10, fontSize: 12 }}>
                                  Kampanyalardan haberdar olmak için Emin Üstün Holding Şirketleri'nden ticari elektronik ileti
                                  almak istiyorum.
                                </span>
                              </div>

                            </div>
                            <div className="row no-gutters p-2 justify-content-center">
                              <div className="col-auto">
                                <button type="submit" className="t-loginGirisButton"
                                  onClick={this.beginAddLead}>
                                  <span />
                                  Bilgilerimi Gönder
                                </button>
                              </div>
                            </div>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-10 col-md-7 col-lg-6 col-xl-4" style={{ padding: '0 2.0em 0 2.0em' }}>
                <div className="row no-gutters">
                  <div className="col-12 col-xl t-loginFooterText1" />
                  <div className="col-12 col-xl-auto p-1"><a href="#" className="t-loginFooterText" onClick={this.getKvkk}>Kişisel Verilerin Korunması</a></div>
                  <div className="col-12 col-xl-auto p-1">

                    <a
                      href="#termOfUseModal"
                      className="t-loginFooterText"
                      data-toggle="modal"
                      data-target="#termOfUseModal"
                    >
                      Kullanım Koşulları

                    </a>
                  </div>
                </div>
              </div>
            </div>
            <TermsOfUse></TermsOfUse>

          </div>
          <div className="t-loginTradeMark" style={{ left: '0' }}>{this.state.ip}</div>
          <div className="t-loginTradeMark">© EMİNEVİM tüm hakları saklıdır.</div>
        </div>


        <KvkkModal
          isOpen={this.state.isKvkkModalOpen}
          kvkkMetni={this.state.kvkkMetni}
          onClose={this.closeKvkkModal}
        />

        <StaticModal></StaticModal>
        <SmsVerify></SmsVerify>
        <ExpirePassword></ExpirePassword>
      </LoadingOverlay>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    alert: selectAlertMessage(state),
    login: selectAuthenticate(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  beginAuthenticate: (postData) => dispatch(beginAuthenticate(postData)),
  beginControlCandidate: (postData) =>
    dispatch(beginControlCandidate(postData)),
  beginAddLead: (postData) => dispatch(beginAddLead(postData)),
  authenticateOtp: (postData) => dispatch(authenticateOtp(postData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
